import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { BRANDING_CONFIGS } from '@branding/branding.config';

@Injectable({
  providedIn: 'root',
})
export class BrandingService {
  private readonly titleService = inject(Title);

  brand = BRANDING_CONFIGS['default'];
  versionInfo: string | undefined = undefined;

  updateBranding() {
    const hostname = window.location.hostname;
    const currentBrand = BRANDING_CONFIGS[hostname] || BRANDING_CONFIGS['default'];
    this.versionInfo = currentBrand?.versionInfo;

    this.brand = currentBrand;

    this.titleService.setTitle(currentBrand.title);

    const favicon = document.getElementById('favicon') as HTMLLinkElement;
    if (favicon) {
      favicon.type = currentBrand.logo.favicon.type === 'svg' ? 'image/svg+xml' : 'image/png';
      favicon.href = currentBrand.logo.favicon.icon;
    }
  }
}
